import axiosPost from "../axiosPost";

export const migraPasoDel = async ({ migraPasoId }, credentials) => {
    const body = {
        service: "MigraPasoDel",
        params: {
            migraPasoId,
        },
    };

    return await axiosPost(body, credentials);
};
